import React from "react";
import DefaultSubTemplate from "components/templates/default/DefaultSubTemplate";

export default React.createContext({
  subTemplate: DefaultSubTemplate,
  getSubTemplate: () => DefaultSubTemplate,
});
